import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
	userLogin(state, username, password, callbacks)	{
        // form_login (parity with develop-v2 / LMS Audit::getToken()):
        // send _username/_password as application/x-www-form-urlencoded.
        let params = qs.stringify({
        	"_username": username,
        	"_password": password
        });
        Vue.axios.post(state.loginUrl, params, {"headers": state.postHeaders}).then((response) => {
            if (response.status == 200)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            // defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            // defaultFailErrorCallback();
            return false;
        }); 
	},
    userRefresh(state, callbacks)  {
        let params = qs.stringify({
            "refresh_token": state.refreshToken
        });

        Vue.axios.post(state.refreshUrl, params, {"headers": state.postHeaders}).then((response) => {
            if (response.status == 200)  {
                if (callbacks.success)  {
                    callbacks.success(response.data);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            // defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            // defaultFailErrorCallback();
            return false;
        }); 
    }
};